import P2Regular from 'components/typography/P2Regular';
import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';

/**
 * Column for the serial number.
 */
export default function SerialNumberColumn({ data: { serialNumber } }: { data: MeasuringDeviceRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {serialNumber}
    </P2Regular>
  );
}
